/* eslint semi:0 */
import { isInIframe, path } from '../../utils/ua'

if (shouldUseIframeResizer()) {
  require('iframe-resizer').iframeResizerContentWindow
}

function shouldUseIframeResizer() {
  return isInIframe && (path.isEmbedded || path.isSyndication)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/embed/embedGuestProvider.js